<template>
    <b-modal ref="mdlNuovoReparto" title="Nuovo Reparto" centered no-close-on-backdrop no-close-on-esc hide-header-close>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Codice</label>
                <b-form-input v-model="jsonData.codiceReparto"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <label class="sa-label-data">Nome Reparto</label>
                <b-form-input v-model="jsonData.descrizioneReparto"></b-form-input>
            </b-col>
        </b-row>
        <template #modal-footer>
            <b-button variant="outline-danger" @click="onCloseModal">Annulla</b-button>
            <b-button variant="outline-success" @click="onSave">Salva</b-button>
        </template>
        <modal-error ref="cmpModalError"></modal-error>
    </b-modal>
</template>

<script>
import UtilityMixin from "../../../utility/UtilityMixin";
import ModalError from "../../../../template/components/modal/components/ModalError.vue";
export default {
    mixins: [UtilityMixin],
    components: { ModalError },
    data() {
        return {
            title: null,
            isRequired: false,
            pathResource: "/rsastruttureprovenienzareparti",

            jsonData: {
                id: null,
                idRsaStrutturaProvenienza: null,
                codiceReparto: null,
                descrizioneReparto: null,
            },
        };
    },
    methods: {
        init(idRsaStrutturaProvenienza) {
            let me = this;
            me.jsonData.idRsaStrutturaProvenienza = idRsaStrutturaProvenienza;
            me.$refs.mdlNuovoReparto.show();
        },
        onCloseModal() {
            let me = this;
            me.jsonData = {
                id: null,
                idLaboratorio: null,
                codiceReparto: null,
                descrizioneReparto: null,
            };
            me.$refs.mdlNuovoReparto.hide();
            me.$emit("closeModal");
        },
        onSave() {
            let me = this;
            me.saveResource(me.pathResource, me.jsonData, me.impegnativaGruppoPrestazioneSuccessSave, null);
        },
        impegnativaGruppoPrestazioneSuccessSave(response) {
            let me = this;
            me.$emit("onSave", response);
            me.$refs.mdlNuovoReparto.hide();
            me.$bvToast.toast("Salvataggio avvenuto con successo", {
                title: "Successo",
                variant: "success",
                solid: true,
            });
        },
    },
};
</script>
